
import { createSlice } from "@reduxjs/toolkit";
import * as app_consts from "../../utils/app_consts";

const initialState = {
 tenant_toggle_sales_rep_brand_product_type: { message: "idle" },
};

export const tenant_toggle_sales_rep_brand_product_type_Slice = createSlice({
 name: "tenant_toggle_sales_rep_brand_product_type",
 initialState,
 reducers: {
  success_tenant_toggle_sales_rep_brand_product_type: (state, action) => {
   state.tenant_toggle_sales_rep_brand_product_type = { status: app_consts.SUCCESS, data: action.payload };
  },
  fail_tenant_toggle_sales_rep_brand_product_type: (state, action) => {
   state.tenant_toggle_sales_rep_brand_product_type = { status: app_consts.FAIL, message: action.payload };
  },
  reset_tenant_toggle_sales_rep_brand_product_type: (state) => {
   state.tenant_toggle_sales_rep_brand_product_type = { status: app_consts.IDLE };
  },
  loading_tenant_toggle_sales_rep_brand_product_type: (state) => {
   state.tenant_toggle_sales_rep_brand_product_type = { status: app_consts.LOADING };
  },
 }
});

export const { success_tenant_toggle_sales_rep_brand_product_type, fail_tenant_toggle_sales_rep_brand_product_type, reset_tenant_toggle_sales_rep_brand_product_type, loading_tenant_toggle_sales_rep_brand_product_type } = tenant_toggle_sales_rep_brand_product_type_Slice.actions;

export default tenant_toggle_sales_rep_brand_product_type_Slice.reducer;